<ng-container *transloco="let t">
  <div style="display: flex; flex-direction: column; align-items: center">
    <mat-card class="antibiogram-card">
      <div class="antibiogram-header">
        <h2 class="title">{{ t('Antibiogram Title') }}</h2>
        <div class="subtitle">{{ t('Antibiogram Swab Note') }}</div>
      </div>
      <div class="antibiogram-table" [formGroup]="form">
        <div class="table-row">
          <div class="label">{{ t('Amoxiclav') }}</div>
          <div class="control">
            <input matInput class="result-input" formControlName="amoksiklav" />
          </div>
        </div>
        <div class="table-row">
          <div class="label">{{ t('Amikacin') }}</div>
          <div class="control">
            <input matInput class="result-input" formControlName="amikacin" />
          </div>
        </div>
        <div class="table-row">
          <div class="label">{{ t('Gentamicin') }}</div>
          <div class="control">
            <input matInput class="result-input" formControlName="gentamicin" />
          </div>
        </div>
        <div class="table-row">
          <div class="label">{{ t('Penicillin') }}</div>
          <div class="control">
            <input matInput class="result-input" formControlName="penicilin" />
          </div>
        </div>
        <div class="table-row">
          <div class="label">{{ t('Trimethoprim-sulfamethoxazole') }}</div>
          <div class="control">
            <input
              matInput
              class="result-input"
              formControlName="trimetoprimSulfo"
            />
          </div>
        </div>
        <div class="table-row">
          <div class="label">{{ t('Ceftriaxone') }}</div>
          <div class="control">
            <input
              matInput
              class="result-input"
              formControlName="ceftriakson"
            />
          </div>
        </div>
        <div class="table-row">
          <div class="label">{{ t('Ciprofloxacin') }}</div>
          <div class="control">
            <input
              matInput
              class="result-input"
              formControlName="ciprofloksacin"
            />
          </div>
        </div>
        <div class="table-row">
          <div class="label">{{ t('Enrofloxacin') }}</div>
          <div class="control">
            <input
              matInput
              class="result-input"
              formControlName="enrofloksacin"
            />
          </div>
        </div>
        <div class="table-row">
          <div class="label">{{ t('Doxycycline') }}</div>
          <div class="control">
            <input
              matInput
              class="result-input"
              formControlName="doksiciklin"
            />
          </div>
        </div>
        <div class="table-row">
          <div class="label">{{ t('Tetracycline') }}</div>
          <div class="control">
            <input
              matInput
              class="result-input"
              formControlName="tetraciklin"
            />
          </div>
        </div>
        <div class="table-row">
          <div class="label">{{ t('Cephalexin') }}</div>
          <div class="control">
            <input matInput class="result-input" formControlName="cefaleksin" />
          </div>
        </div>
        <div class="table-row">
          <div class="label">{{ t('Ampicillin') }}</div>
          <div class="control">
            <input matInput class="result-input" formControlName="ampiciin" />
          </div>
        </div>
        <div class="table-row full-width">
          <div class="label">{{ t('Fungi') }}</div>
          <div class="control">
            <input matInput class="result-input" formControlName="fungi" />
          </div>
        </div>
        <div class="table-row full-width" style="margin-top: 8px">
          <div class="label">{{ t('Veterinarian name and surname') }}</div>
          <div class="control">
            <input
              matInput
              class="result-input"
              formControlName="veterinarianName"
            />
          @if (form.get('veterinarianName')?.invalid && form.get('veterinarianName')?.touched) {
            <div class="mat-error" style="font-size:12px;color:#f44336">{{ t('This field is required') }}</div>
          }
          </div>
        </div>
      </div>
    </mat-card>
  </div>
</ng-container>
